import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Course } from 'lms-api';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faCircle as faCircleRegular } from '@fortawesome/free-regular-svg-icons';
import { faCircle as faCircleSolid } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-course-slideshow',
  templateUrl: './course-slideshow.component.html',
  styleUrls: ['./course-slideshow.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CourseSlideshowComponent implements OnInit, OnChanges {
  @Input() courses: Course[];
  public showCourses: Course[];
  public carouselInfinite: boolean = true;
  public carouselSlidesToShow: number = 4;

  constructor() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.carouselInfinite = changes.courses.currentValue.length > 4;
    this.carouselSlidesToShow = changes.courses.currentValue.length > 4 ? 4 : changes.courses.currentValue.length;
  }

  public ngOnInit(): void {
  }
}
